import { render, staticRenderFns } from "./CreateAdvertiser.vue?vue&type=template&id=42b51b8d&"
import script from "./CreateAdvertiser.vue?vue&type=script&lang=ts&"
export * from "./CreateAdvertiser.vue?vue&type=script&lang=ts&"
import style0 from "./CreateAdvertiser.vue?vue&type=style&index=0&id=42b51b8d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports